import { faBox, faBriefcase, faBuilding, faCopy, faCube, faFileAlt, faFileMedical, faGlobe, faKey, faLayerGroup, faSearch, faSignature, faUser, faUserFriends, faUserGraduate, faUserPlus, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import LayoutPrimary from '../components/Layouts/LayoutPrimary/LayoutPrimary';
import { useLang } from '../language';
import { Dashboard } from '../pages/Dashboard';
import { Sellos } from '../pages/Sellos';
import { Solicitudes } from '../pages/Solicitudes';
import { RootState } from '../store';
import { isColegiado, isPreColegiado } from './helpers';
import { ActualizacionDatos } from '../pages/ActualizacionDatos';
import { AltaGuiaProfesionales } from '../pages/AltaGuiaProfesionales';
import { AltaRegistroCertificadores } from '../pages/AltaRegistroCertificadores';
import { RolRoute } from './RolRoute';
import { AccesoEmpresasRoute } from './AccesoEmpresasRoute';
import { PeritosTercerosAdministracion } from '../pages/PeritosTercerosAdministracion';
import { SolicitudOtec } from '../pages/SolicitudOtec';
import { Empresas } from '../pages/Empresas';
// Modulos de administracion

export const PrivateRouter = () => {

    const { auth } = useSelector((state: RootState) => state.auth)

    // Solo sale el acceso al módulo de empresas si el usuario tiene alguna empresa
    // autorizada. Lo rellena `AppRouter` al arrancar (`GET /integra-web/empresas/mi-acceso`).
    // Con `null` (todavía sin consultar) tampoco sale, igual que con `false`.
    const { tieneEmpresasAutorizadas } = useSelector((state: RootState) => state.empresa)

    const isLogged = !isEmpty(auth)

    const Lang = useLang()

    const navGroups = [
        {
            key: 'FORMACION',
            title: Lang('GRUPO_FORMACION'),
            icon: <FontAwesomeIcon icon={faUserGraduate} />
        },
        {
            key: 'SERVICIOS',
            title: Lang('GRUPO_SERVICIOS'),
            icon: <FontAwesomeIcon icon={faBriefcase} />
        },
        {
            key: 'TRAMITES',
            title: Lang('GRUPO_TRAMITES'),
            icon: <FontAwesomeIcon icon={faFileAlt} />
        },
    ]

    const agruparMenu = isColegiado(auth.rol) || isPreColegiado(auth.rol)

    const navLinks = [
        {
            icon: <FontAwesomeIcon icon={faUser} />,
            title: Lang('MI_COLEGIO'),
            link: '/el-meu-col-legi',
            show: true
        },
        // --- Formación ---
        {
            icon: <FontAwesomeIcon icon={faFileMedical} />,
            title: Lang('GESTIONA_TUS_INSCRIPCIONES'),
            link: 'https://activitats.enginyersbcn.cat/ac_inicio.php',
            external: true,
            group: 'FORMACION',
            show: true
        },
        {
            icon: <FontAwesomeIcon icon={faGlobe} />,
            title: Lang('CAMPUS_VIRTUAL'),
            link: 'https://tecnoaula.enginyersbcn.cat/formacio/auth/jwt/custom_login.php?auto_login=true',
            external: true,
            group: 'FORMACION',
            show: true
        },
        {
            icon: <FontAwesomeIcon icon={faLayerGroup} />,
            title: Lang('CATALOGO_DE_CURSOS'),
            link: 'https://tecnoaula.enginyersbcn.cat/cataleg.php',
            external: true,
            group: 'FORMACION',
            show: true
        },
        // --- Servicios profesionales ---
        {
            icon: <FontAwesomeIcon icon={faCopy} />,
            title: Lang('BUSCADOR_DOCUMENTACION_SEGUIMIENTO'),
            link: 'https://documentacio.enginyersbcn.cat/coneixement',
            external: true,
            group: 'SERVICIOS',
            show: isColegiado(auth.rol) || isPreColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faSearch} />,
            title: Lang('TECNOVISAT'),
            link: 'https://tecnovisat.enginyersbcn.cat/colegiado/index.php',
            external: true,
            group: 'SERVICIOS',
            show: isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faBriefcase} />,
            title: Lang('BOLSA_DE_TRABAJO'),
            link: 'https://borsatreball.enginyersbcn.cat/colegiado/inicio.php',
            external: true,
            group: 'SERVICIOS',
            show: isColegiado(auth.rol) || isPreColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faKey} />,
            title: Lang('SLAM'),
            link: 'https://webpre.enginyersbcn.cat/serveis/serveis-tecnics/slam-servei-de-lloguer-daparells-de-mesura/',
            external: true,
            group: 'SERVICIOS',
            show: isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faBox} />,
            title: Lang('DL_ABSTRACT'),
            link: 'https://infocentre.io/ca/auth/login?id_bt=cmc065t320007tqex0hbiu41y',
            external: true,
            group: 'SERVICIOS',
            show: isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faCube} />,
            title: Lang('TOOLBOX'),
            link: 'https://toolbox.cogiti.es/',
            external: true,
            group: 'SERVICIOS',
            show: isColegiado(auth.rol)
        },
        // --- Trámites ---
        {
            icon: <FontAwesomeIcon icon={faUserPlus} />,
            title: Lang('ALTA_GUIA_PROFESIONALES'),
            link: '/alta-guia-professionals',
            group: 'TRAMITES',
            show: isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faStickyNote} />,
            title: Lang('SOLICITUD_OTED'),
            link: '/alta-guia-etec',
            group: 'TRAMITES',
            show: isColegiado(auth.rol)
        },
        // {
        //     icon: <FontAwesomeIcon icon={faFileMedical} />,
        //     title: Lang('ALTA_REGISTRO_CERTIFICADORES_EFICIENCIA_ENERGETICA'),
        //     link: '/certificador-eficiencia-energetica',
        //     group: 'TRAMITES',
        //     show: isColegiado(auth.rol)
        // },
        {
            icon: <FontAwesomeIcon icon={faUserFriends} />,
            title: Lang('PERITOS_TERCEROS_ADMINISTRACION'),
            link: '/perits-tercers-administracio',
            group: 'TRAMITES',
            show: isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faUser} />,
            title: Lang('ACTUALIZACION_DATOS'),
            link: '/actualitzacio-dades',
            group: 'TRAMITES',
            show: isColegiado(auth.rol) || isPreColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faFileAlt} />,
            title: Lang('SOLICITUDES'),
            link: '/sol-licituds',
            group: 'TRAMITES',
            show: isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faSignature} />,
            title: Lang('SELLOS'),
            link: '/segells',
            group: 'TRAMITES',
            show: isColegiado(auth.rol)
        },
        // --- Sueltos ---
        {
            icon: <FontAwesomeIcon icon={faUserGraduate} />,
            title: Lang('AREA_DE_COLEGIACION'),
            link: 'https://webpre.enginyersbcn.cat/collegiat/em-vull-collegiar/',
            external: true,
            show: !isColegiado(auth.rol)
        },
        {
            icon: <FontAwesomeIcon icon={faBuilding} />,
            title: Lang('EMPRESAS'),
            link: '/empreses',
            show: tieneEmpresasAutorizadas === true
        },
    ]

    return (
        <section className='LayoutPrimary animate__animated animate__fadeIn'>

            <LayoutPrimary label={Lang('AREA_DE_ADMINISTRACION')}>

                <LayoutPrimary.Navtop />

                <LayoutPrimary.Navleft
                    navLinks={navLinks?.filter((item: any) => item.show)}
                    navGroups={agruparMenu ? navGroups : []}
                />

                <LayoutPrimary.Body>

                    <Routes>

                        <Route path='/actualitzacio-dades/*' element={<RolRoute isAllowedRol={isColegiado(auth.rol) || isPreColegiado(auth.rol)} onlyPath='' />}>

                            <Route path='*' element={<ActualizacionDatos onlyPath='/actualitzacio-dades' />} />

                        </Route>

                        <Route
                            path='/el-meu-col-legi'
                            element={<Dashboard />}
                        />

                        <Route path='/alta-guia-professionals' element={<RolRoute isAllowedRol={isColegiado(auth.rol)} onlyPath='' />}>

                            <Route index element={<AltaGuiaProfesionales />} />

                        </Route>

                        {/* <Route path='/certificador-eficiencia-energetica/*' element={<RolRoute isAllowedRol={isColegiado(auth.rol)} onlyPath='' />}>

                            <Route path='*' element={<AltaRegistroCertificadores onlyPath='/certificador-eficiencia-energetica' />} />

                        </Route> */}

                        <Route path='/perits-tercers-administracio/*' element={<RolRoute isAllowedRol={isColegiado(auth.rol)} onlyPath='' />}>

                            <Route path='*' element={<PeritosTercerosAdministracion onlyPath='/perits-tercers-administracio' />} />

                        </Route>


                        <Route path='/segells/*' element={<RolRoute isAllowedRol={isColegiado(auth.rol)} onlyPath='' />}>

                            <Route path='*' element={<Sellos onlyPath='/segells' />} />

                        </Route>

                        <Route path='/empreses/*' element={<AccesoEmpresasRoute />}>

                            <Route path='*' element={<Empresas onlyPath='/empreses' />} />

                        </Route>

                        <Route path='/sol-licituds/*' element={<RolRoute isAllowedRol={isColegiado(auth.rol)} onlyPath='' />}>

                            <Route path='*' element={<Solicitudes onlyPath='/sol-licituds' />} />

                        </Route>

                        <Route path='/alta-guia-etec' element={<RolRoute isAllowedRol={isColegiado(auth.rol)} onlyPath='' />}>

                            <Route index element={<SolicitudOtec />} />

                        </Route>

                        <Route
                            path="*"
                            element={<Navigate to="/el-meu-col-legi" replace />}
                        />

                    </Routes>

                </LayoutPrimary.Body>

            </LayoutPrimary>

        </section>
    )
}
